import { createFileRoute } from '@tanstack/react-router';
import { AssessmentCreatePage } from '@/pages/assessment/ui/AssessmentCreatePage';

export const Route = createFileRoute('/_protected/assessment/create')({
  component: AssessmentCreatePage,
});
